export const NEWSLETTER_TAGS = {
    SUBSCRIPTION_LIST: "getSubscriptionList",
} as const;